import AMLCheckResult from './AMLCheckResult';

export default AMLCheckResult;
